import '.cd{display:inline-flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.jd{padding:0.6rem;}.ssr-plugin'
import '.hp{border-radius:1.875rem;}.ssr-plugin'
import '.je{border:1px solid var(--palette-blue-50);}.ssr-plugin'
import '.jf{box-shadow:0 1rem 2rem 0.5rem var(--palette-blue-50);}.ssr-plugin'
import '.jg{--page-min-height:auto;}.ssr-plugin'
import '.dh{border-radius:2rem;}.ssr-plugin'
import '.jh{overflow-x:hidden;}.ssr-plugin'
import '.c3{overflow-y:auto;}.ssr-plugin'
import '.ji{background:var(--page-bg);}.ssr-plugin'
import '.ao{position:relative;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { ReactNode } from 'react'

export type PhoneFrameProps = {
  children: ReactNode
  width?: number
  height?: number
  style?: Style
}

export const PhoneFrame = ({
  children,
  width = 390,
  height = 760,
  style,
}: PhoneFrameProps) => {
  return (
    <styled.div className="cd b t v jd hp je jf"
      style={{
        ...style,
      }}
    >
      <styled.div className="jg dh jh c3 ji ao"
        style={{
          width,
          height,} as Style}
      >
        <div style={{ pointerEvents: 'none' }}>{children}</div>
      </styled.div>
    </styled.div>
  )
}
